import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {useAdDimensions} from 'app/components/ads/useAdDimensions';
import {AdCore} from 'app/components/ads/AdCore';
import {selectDistrict} from 'app/hooks/reduxCreateSelectorHooks';

// AdSlotContainer: Component to set configuration to define ad slot
// only triggered in CSR
const AdSlotContainer = ({adUnit, limitedDim, adLayout, className}) => {
  const selectedDistrict = useSelector(selectDistrict);
  const [region, setRegion] = useState(selectedDistrict?.region?.slug || 'global');

  useEffect(() => {
    if (selectedDistrict?.region) {
      setRegion(selectedDistrict?.region?.slug);
    }
  }, [selectedDistrict]);

  const dimensions = useAdDimensions(limitedDim);
  const sizes = dimensions[adUnit];

  // adUnitCode needs to be unique for each container per page
  const networkCodeQM = '27763518,1037284';
  const adUnitCode = `/${networkCodeQM}/FuPa_GmbH/fupa.net/${region}/${adUnit}`;

  return (
    <div className={className}>
      <AdCore id={`ad-${adUnit}`} adLayout={adLayout} adUnitCode={adUnitCode} sizes={sizes} />
    </div>
  );
};

export {AdSlotContainer};
